import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import SingleAppShowCase from '../components/SingleAppShowcase'

// Demo Showcase
import petPursuitDemo from '../img/petPursuitShowcase.png'

// Website Logos
import petPursuitLogo from '../img/petPursuitLogo.png'

class Websites extends Component {

  render() {
    return (
      <div
        className="align-items-center"
      >
      <Header
        title="Websites"
      />
        <SingleAppShowCase
          backgroundColor={'#FFF'}
          appTitle={"PetPursuit"}
          appLogo={petPursuitLogo}
          logoWidth={"50%"}
          appDescription="Pet Pursuit started out as an app for my mobile computing applications course at Missouri State and once
          the course has wrapped up I decided to work on it as a personal project. This website was made to showcase the design and
          features of the application as it is in development"
          appVisual={petPursuitDemo}
          url={"http://petpursuit.org"}
        />
      </div>
    );
  }
}

export default Websites;



// WEBPACK FOOTER //
// ./src/screens/Websites.js